const map = {
	"./24Hours.png": 99173,
	"./bequem.png": 11899,
	"./green.png": 98471,
	"./hilfsbereit.png": 3639,
	"./preise-leistungs.png": 86355,
	"./qualität.png": 20266,
	"./smart.png": 93493
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51551;